import store from '../store/index';

const createUserGuard = (to, from, next) => {
  next();
  // store.dispatch('ingredients/LoadAllergens'
  // ).then(() => next());
}

export default createUserGuard;
